
import { useState } from 'react';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How long does a typical pool remodeling project take?',
      answer: 'Most pool remodeling projects take between 2-4 weeks depending on the scope of work. Simple plaster repairs may take just a few days, while complete renovations with new tile, coping, and decking can take up to 4 weeks. We\'ll provide a detailed timeline during your free consultation.'
    },
    {
      question: 'Do you offer free estimates?',
      answer: 'Yes! We provide free, no-obligation estimates for all our services. Our team will visit your property, assess your needs, and provide a detailed written quote. There\'s no pressure to commit, and we\'re happy to answer any questions you have.'
    },
    {
      question: 'Are you licensed and insured in Nevada?',
      answer: 'Absolutely. RW Construction Las Vegas LLC is fully licensed, bonded, and insured in the state of Nevada. We carry comprehensive liability insurance and workers\' compensation coverage to protect both our clients and our team members.'
    },
    {
      question: 'What areas do you serve in Las Vegas?',
      answer: 'We serve the entire Las Vegas Valley including Las Vegas, Henderson, North Las Vegas, Summerlin, Green Valley, Paradise, Spring Valley, Enterprise, Boulder City, Pahrump, Mesquite, and Sunrise Manor. We also service areas within a 60-mile radius of Las Vegas.'
    },
    {
      question: 'How does your financing work?',
      answer: 'We partner with trusted financing companies to offer flexible payment plans with competitive interest rates. The application process is quick and easy, with most approvals happening within 24-48 hours. We can discuss financing options during your consultation to find a plan that fits your budget.'
    },
    {
      question: 'What is the warranty on your work?',
      answer: 'We stand behind our craftsmanship with comprehensive warranties. Most of our work comes with a minimum 1-year workmanship warranty, and many materials carry manufacturer warranties of 5-25 years. Specific warranty details are provided in writing with every project contract.'
    },
    {
      question: 'Can you work on commercial properties?',
      answer: 'Yes, we have extensive experience with commercial projects including HOA communities, apartment complexes, hotels, and business properties. We understand the unique requirements of commercial work and can schedule projects to minimize disruption to your operations.'
    },
    {
      question: 'How do I get started with my project?',
      answer: 'Getting started is easy! Simply call us at (702) 123-4567 or fill out our contact form to schedule a free consultation. We\'ll discuss your vision, assess your property, provide a detailed estimate, and create a timeline that works for you.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white" itemScope itemType="https://schema.org/FAQPage">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">FAQ</span>
          </div>
          <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">Frequently Asked<br />Questions</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Find answers to common questions about our services, process, and policies
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              itemScope 
              itemProp="mainEntity" 
              itemType="https://schema.org/Question"
              className={`bg-[#FAF8F5] rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'shadow-lg' : 'shadow-sm hover:shadow-md'}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h3 itemProp="name" className="text-lg font-bold text-[#2C2C2C] pr-4">{faq.question}</h3>
                <div className={`w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-white text-xl"></i>
                </div>
              </button>
              <div 
                itemScope 
                itemProp="acceptedAnswer" 
                itemType="https://schema.org/Answer"
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p itemProp="text" className="px-6 pb-6 text-gray-600 text-base leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-[#2C2C2C] rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-white mb-3">Still Have Questions?</h3>
          <p className="text-gray-300 mb-6">Our team is here to help. Contact us for personalized assistance.</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#E55A2B] transition-all hover:scale-105 inline-flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            Contact Us
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
